import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

class NotFound extends React.Component {
	render() {
		return (
			<React.Fragment>
				{this.props.failedLink ? null : <Header />}

				<div
					style={{ backgroundColor: '#FAFBFC', float: 'none', marginTop: '90px', marginBottom: '90px' }}
					className="col-md-6 col-md-offset-3 text-center"
				>
					<h1 style={{ fontSize: '35px' }}>
						<i
							className="fa fa-exclamation-triangle text-warning margin-20"
							style={{ fontSize: '2em' }}
						/>{' '}
						<br /> El sitio no está disponible
					</h1>
					<p className="lead margin-40">
						{this.props.content ||
							`En este momento no es posible conectarse a la página, volvé a intentarlo o ingresá en otro
						momento.`}
					</p>
					<p className="margin-60">
						<a href={this.props.link || 'https://www.argentina.gob.ar/produccion'} class="btn btn-primary">
							{this.props.linkText || 'Ir la página de inicio de Produccion.gob.ar'}
						</a>
					</p>

					<form
						className="main-form"
						role="search"
						action={this.props.link || 'https://www.argentina.gob.ar/produccion'} //TODO Agregar nueva URL
						method="get"
						accept-charset="UTF-8"
					/>
				</div>

				{this.props.failedLink ? null : <Footer />}
			</React.Fragment>
		);
	}
}

export default NotFound;
